const updates = [
  { date: '08-01', title: '《星际迷航：新纪元》蓝光高清版上线', tag: '新片', tagAccent: true },
  { date: '07-31', title: '《夜雨江湖》4K修复版独家首播', tag: '热播', tagAccent: false },
  { date: '07-30', title: '暑期档特辑：十大科幻巨制限时连播', tag: '专题', tagAccent: false },
  { date: '07-29', title: '《深海迷城》院线同步高清上线', tag: '院线', tagAccent: true },
  { date: '07-28', title: '经典港片修复计划第三批片单公布', tag: '经典', tagAccent: false },
  { date: '07-27', title: '《荒野追凶》未删减导演版独家放送', tag: '独家', tagAccent: true },
  { date: '07-26', title: '动画电影专区全新改版上线', tag: '改版', tagAccent: false },
  { date: '07-25', title: '《月下奇谭》中文字幕精校版发布', tag: '新片', tagAccent: false },
];

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <i className="ri-flashlight-line text-accent-500 text-sm"></i>
            <span className="text-xs font-medium text-accent-600 whitespace-nowrap">实时更新</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            新片速递
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-200 max-w-lg mx-auto">
            最新电影资源每日同步更新，不再错过任何一部精彩大片
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>

          <div className="flex flex-col gap-6">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative flex items-start gap-6 ${
                  i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className="hidden md:flex flex-1"></div>

                <div className="relative z-10 flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-50 border-2 border-background-300">
                  <div className={`w-2.5 h-2.5 rounded-full ${i === 0 || i === 3 || i === 5 ? 'bg-accent-500' : 'bg-secondary-400'}`}></div>
                </div>

                <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs font-mono text-foreground-300 bg-background-100 px-2 py-0.5 rounded">
                      {item.date}
                    </span>
                    <span
                      className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
                        item.tagAccent
                          ? 'bg-accent-100 text-accent-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-50 font-medium">
                    {item.title}
                  </p>
                </div>

                <div className="hidden md:flex flex-1"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}